import { useQuery } from '@hooks/reactQuery';

import { getAssetHistoryProfile, getAssetLog } from '@api/assetLogs';

import { extractQueryParams } from '@utils/common';

import { IGetAssetLogDTO } from '@interfaces/assets/dto/assetsDTO';

import { refetchOptions } from '@constants/common';
import { ASSET_HISTORY_PROFILE, ASSET_LOGS_FILTER } from '@constants/queryKeys';

export const useAssetHistoryProfile = (params?: { assetId?: string }) => {
	const { assetId } = params || {};

	const {
		data: profileVersions,
		isLoading: isLoadingAssetLogs,
		isFetching: isFetchingAssetLogs,
	} = useQuery({
		queryKey: [
			ASSET_HISTORY_PROFILE,
			assetId,
		],
		queryFn: extractQueryParams(getAssetHistoryProfile),
		enabled: [assetId],
		...refetchOptions,
	});

	return {
		currentVersion: profileVersions?.current || {},
		previousVersion: profileVersions?.previous || {},
		isLoading: isLoadingAssetLogs || isFetchingAssetLogs,
	};
};

interface IUseAssetHistoryParams extends IGetAssetLogDTO {
	isAssetOwner?: boolean;
}

export const useQueryAssetHistory = (params?: IUseAssetHistoryParams) => {
	const {
		isAssetOwner,
	} = params || {};

	const {
		data,
		isLoading: isLoadingAssetLogs,
		isFetching: isFetchingAssetLogs,
	} = useQuery({
		queryKey: [
			ASSET_LOGS_FILTER,
			params,
		],
		queryFn: extractQueryParams(getAssetLog),
		enabled: [isAssetOwner],
		refetchOnWindowFocus: false,
	});

	return {
		countOfRecords: data?.count || 0,
		assetHistoryByFilter: data?.items || [],
		isLoading: isLoadingAssetLogs || isFetchingAssetLogs,
	};
};
